(function () {
    "use strict";

    function isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );
    }

    if (isMobileDevice()) {
        const configurator = document.querySelector(".configurator");
        if (configurator) {
            configurator.style.display = "none";
        }
        return;
    }

    const productInfo = document.querySelector(".product-info") || document.body;
    const pageHeading = document.querySelector("h1");
    const pageText = normalizeText([
        document.title,
        pageHeading ? pageHeading.textContent : "",
        productInfo.textContent
    ].join(" "));

    const isRigaSSize = pageText.includes("bus shelter riga s size");
    const isRigaMSize = pageText.includes("bus shelter riga m size");
    const isRigaLSize = pageText.includes("bus shelter riga l size");
    const isRigaXlSize = pageText.includes("bus shelter riga xl size"); // Added XL size

    if (isRigaSSize || isRigaMSize || isRigaLSize || isRigaXlSize) {
        let sizeIndicator = "S";
        if (isRigaXlSize) sizeIndicator = "XL"; // Added XL size handling
        if (isRigaLSize) sizeIndicator = "L";
        if (isRigaMSize) sizeIndicator = "M";
        initRigaNewConfigurator(productInfo, sizeIndicator);
    } else {
        initLegacyConfigurator(productInfo);
    }

    function normalizeText(value) {
        return String(value || "")
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, " ")
            .replace(/\s+/g, " ")
            .trim();
    }

    function getUnityIframe() {
        return document.getElementById("webglIframe") || document.querySelector("iframe");
    }

    function initRigaNewConfigurator(root, sizeName) {
        const logPrefix = "[Shopify/RIGA " + sizeName + "]";
        console.log("🚀 " + logPrefix + " Configurator script started");

        const itemPatterns = {
            rearDisplay: /rear section (led )?display|rear display/,
            sideDisplay: /side section led display/,
            sideGlass: /side section glass/,
            posterFrame: /poster frame/,
            standingBench: /standing bench/,
            glassPrint: /glass print/
        };

        let unityReady = false;
        let controlsReady = false;
        let initialStateSent = false;
        let forcingPosterSelection = false;
        let syncScheduled = false;

        const lastSent = Object.create(null);
        let items = {};

        window.addEventListener("message", function (event) {
            const iframe = getUnityIframe();

            if (!iframe || event.source !== iframe.contentWindow) {
                return;
            }

            if (!event.data || event.data.type !== "UNITY_READY") {
                return;
            }

            console.log("🎮 " + logPrefix + " Unity WebGL is ready");
            unityReady = true;
            sendInitialStateWhenReady();
        });

        function findItem(pattern) {
            const checkboxes = root.querySelectorAll('input[type="checkbox"]');
            for (const checkbox of checkboxes) {
                let node = checkbox.parentElement;
                let levels = 0;

                while (node && node !== root.parentElement && levels < 10) {
                    const text = normalizeText(node.textContent);
                    const checkboxCount = node.querySelectorAll('input[type="checkbox"]').length;

                    if (pattern.test(text) && checkboxCount === 1) {
                        return node;
                    }
                    node = node.parentElement;
                    levels += 1;
                }
            }
            return null;
        }

        function discoverItems() {
            items = {
                rearDisplay: findItem(itemPatterns.rearDisplay),
                sideDisplay: findItem(itemPatterns.sideDisplay),
                sideGlass: findItem(itemPatterns.sideGlass),
                posterFrame: findItem(itemPatterns.posterFrame),
                standingBench: findItem(itemPatterns.standingBench),
                glassPrint: findItem(itemPatterns.glassPrint)
            };

            controlsReady = Boolean(
                items.rearDisplay &&
                items.sideDisplay &&
                items.sideGlass &&
                items.posterFrame
            );

            if (controlsReady) {
                sendInitialStateWhenReady();
            }
        }

        function checkboxFor(item) {
            if (!item) return null;
            return item.querySelector('input[type="checkbox"]');
        }

        function selectFor(item) {
            if (!item) return null;
            return item.querySelector("select");
        }

        function isSelected(item) {
            const checkbox = checkboxFor(item);
            return Boolean(checkbox && checkbox.checked);
        }

        function selectedOptionText(item) {
            const select = selectFor(item);
            if (!select) return "";

            const option = select.options[select.selectedIndex];
            return normalizeText(option ? option.textContent : select.value);
        }

        function containsSideWord(value, side) {
            return new RegExp("(^| )" + side + "( |$)").test(value);
        }

        function buildState() {
            const rearVariant = selectedOptionText(items.rearDisplay);
            const sideVariant = selectedOptionText(items.sideDisplay);
            const glassVariant = selectedOptionText(items.sideGlass);
            const posterVariant = selectedOptionText(items.posterFrame);
            const benchVariant = selectedOptionText(items.standingBench);

            const rearEnabled = isSelected(items.rearDisplay);
            const sideEnabled = isSelected(items.sideDisplay);
            const posterEnabled = isSelected(items.posterFrame);
            const benchEnabled = isSelected(items.standingBench);

            const glassEnabled = isSelected(items.sideGlass) && !glassVariant.includes("no side glass");

            let posterSide = "left";
            if (containsSideWord(posterVariant, "right")) {
                posterSide = "right";
            } else if (containsSideWord(posterVariant, "middle")) {
                posterSide = "middle";
            }

            return {
                RearDisplay: {
                    enabled: rearEnabled,
                    doubleSided: rearEnabled && rearVariant.includes("double side"),
                    variant: rearVariant
                },
                SideDisplay: {
                    enabled: sideEnabled,
                    doubleSided: sideEnabled && sideVariant.includes("double side"),
                    variant: sideVariant
                },
                SideGlass: {
                    enabled: glassEnabled,
                    left: glassEnabled && (glassVariant.includes("left side glass") || glassVariant.includes("two side glasses")),
                    right: glassEnabled && (glassVariant.includes("right side glass") || glassVariant.includes("two side glasses")),
                    variant: glassVariant
                },
                PosterFrame: {
                    enabled: posterEnabled,
                    side: posterSide
                },
                StandingBench: {
                    enabled: benchEnabled,
                    withBench: benchEnabled && !benchVariant.includes("without")
                },
                Silluete: items.glassPrint ? isSelected(items.glassPrint) : null
            };
        }

        function forcePosterSelection(targetSide) {
            const posterSelect = selectFor(items.posterFrame);
            if (!posterSelect || forcingPosterSelection) return false;

            const currentPosterVariant = selectedOptionText(items.posterFrame);
            if (containsSideWord(currentPosterVariant, targetSide)) {
                return false;
            }

            const targetOption = Array.from(posterSelect.options).find(function (option) {
                const optionText = normalizeText(option.textContent);
                return containsSideWord(optionText, targetSide);
            });

            if (!targetOption) return false;

            forcingPosterSelection = true;
            posterSelect.value = targetOption.value;
            posterSelect.dispatchEvent(new Event("change", { bubbles: true }));
            forcingPosterSelection = false;

            console.log("↩️ " + logPrefix + " Poster moved to " + targetSide + " due to constraint");
            return true;
        }

        function enforceConstraints(state) {
            let changed = false;
            
            // Constraint 1: Rear display occupies the right side.
            if (state.RearDisplay.enabled && state.PosterFrame.enabled && state.PosterFrame.side === "right") {
                changed = forcePosterSelection("left") || changed;
            }

            // Constraint 2: Standing Bench occupies the middle.
            if (state.StandingBench.withBench && state.PosterFrame.enabled && state.PosterFrame.side === "middle") {
                changed = forcePosterSelection("left") || changed;
            }

            return changed;
        }

        function postToUnity(type, payload, force) {
            if (!unityReady) return;

            const serialized = typeof payload === "boolean" ? String(payload) : JSON.stringify(payload);

            if (!force && lastSent[type] === serialized) {
                return;
            }

            const iframe = getUnityIframe();
            if (!iframe || !iframe.contentWindow) {
                console.error("❌ " + logPrefix + " Unity iframe was not found");
                return;
            }

            lastSent[type] = serialized;
            iframe.contentWindow.postMessage({ type: type, message: serialized }, "*");
            console.log("📤 " + logPrefix, type, serialized);
        }

        function syncAll(force) {
            if (!controlsReady || !unityReady) return;

            const state = buildState();

            if (enforceConstraints(state)) {
                scheduleSync(true);
                return;
            }

            postToUnity("RearDisplay", state.RearDisplay, force);
            postToUnity("SideDisplay", state.SideDisplay, force);
            postToUnity("SideGlass", state.SideGlass, force);
            postToUnity("PosterFrame", state.PosterFrame, force);
            postToUnity("StandingBench", state.StandingBench, force);
            
            if (state.Silluete !== null) {
                postToUnity("Silluete", state.Silluete, force);
            }
        }

        function sendInitialStateWhenReady() {
            if (!unityReady || !controlsReady || initialStateSent) return;

            initialStateSent = true;
            syncAll(true);
        }

        function scheduleSync(force) {
            if (syncScheduled) return;

            syncScheduled = true;
            window.requestAnimationFrame(function () {
                syncScheduled = false;
                discoverItems();
                syncAll(Boolean(force));
            });
        }

        root.addEventListener("change", function (event) {
            if (event.target.matches('input[type="checkbox"], select')) {
                scheduleSync(false);
            }
        });

        const observer = new MutationObserver(function () {
            scheduleSync(false);
        });

        observer.observe(root, { subtree: true, childList: true });

        const main = document.getElementById("main");
        if (main) main.style.overflowX = "visible";

        discoverItems();
    }

    // --- Legacy script below remains unchanged ---
    function initLegacyConfigurator(root) {
        console.log("🚀 [Shopify/Legacy] Configurator script started");

        let isUnityReady = false;
        let areCheckboxesReady = false;
        let initialStatesSent = false;
        let checkboxes;

        window.addEventListener("message", function (event) {
            const iframe = getUnityIframe();
            if (!iframe || event.source !== iframe.contentWindow) return;

            if (event.data && event.data.type === "UNITY_READY") {
                isUnityReady = true;
                checkAndSendInitialStates();
            }
        });

        function checkAndSendInitialStates() {
            if (isUnityReady && areCheckboxesReady && !initialStatesSent) {
                initInitialStates();
                initialStatesSent = true;
            }
        }

        function sendToUnity(type, isChecked) {
            const iframe = getUnityIframe();
            if (!iframe || !iframe.contentWindow) {
                console.error("❌ [Shopify/Legacy] iframe not found");
                return;
            }
            iframe.contentWindow.postMessage({ type: type, message: isChecked ? "true" : "false" }, "*");
        }

        function initInitialStates() {
            if (checkboxes[3] && checkboxes[3].checked) {
                sendToUnity("InnerScreen", true);
                sendToUnity("OuterScreen", true);
            }
            if (checkboxes[4] && checkboxes[4].checked) {
                sendToUnity("InnerSideScreen", true);
                sendToUnity("OuterSideScreen", true);
            }
            if (checkboxes[5] && checkboxes[5].checked) {
                sendToUnity("Map", true);
            }
            if (checkboxes[6] && checkboxes[6].checked) {
                sendToUnity("BusSchedule", true);
            }
            if (checkboxes[7] && checkboxes[7].checked) {
                sendToUnity("Silluete", true);
            }
        }

        function initializeLegacyControls() {
            checkboxes = document.querySelectorAll('input[type="checkbox"]');
            if (checkboxes.length < 8) return false;

            const main = document.getElementById("main");
            if (main) main.style.overflowX = "visible";

            if (checkboxes[0]) {
                checkboxes[0].addEventListener("click", function () {
                    const isMainChecked = checkboxes[0].checked;
                    for (let i = 3; i < 8; i += 1) {
                        if (checkboxes[i] && checkboxes[i].checked !== isMainChecked) {
                            checkboxes[i].click();
                        }
                    }
                });
            }

            checkboxes[3].addEventListener("click", function () {
                sendToUnity("InnerScreen", this.checked);
                sendToUnity("OuterScreen", this.checked);
            });
            checkboxes[4].addEventListener("click", function () {
                sendToUnity("InnerSideScreen", this.checked);
                sendToUnity("OuterSideScreen", this.checked);
            });
            checkboxes[5].addEventListener("click", function () {
                sendToUnity("Map", this.checked);
            });
            checkboxes[6].addEventListener("click", function () {
                sendToUnity("BusSchedule", this.checked);
            });
            checkboxes[7].addEventListener("click", function () {
                sendToUnity("Silluete", this.checked);
            });

            areCheckboxesReady = true;
            checkAndSendInitialStates();
            observer.disconnect();
            return true;
        }

        const observer = new MutationObserver(initializeLegacyControls);
        observer.observe(root, { subtree: true, childList: true });
        initializeLegacyControls();
    }
}());